import axios from "axios"
import global from "../../../globalvar";

let state = {
    visitList: []
};
let getters = {};
let mutations = {
    setVisitList(state, VisitList) {
        state.visitList = VisitList
    }
};
let actions = {
    async loadVisits({commit, dispatch, rootState}) {
        console.log(rootState);
        try {
            commit("appModule/startFetching", null, { root: true });
            let visitList = (await axios.get(global.ApiBaseUrl +"/api/visit/all", {
                headers: {
                    "x-auth-token": JSON.parse(localStorage.getItem("authInfo")).token
                }
            })).data;
            commit("appModule/endFetching", null, { root: true })
            commit("setVisitList", visitList)
            
        } catch (e) {
            dispatch("appModule/addErrorMessage", e, { root: true } )
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}